import dayjs from "dayjs";
import localizedFormat from 'dayjs/plugin/localizedFormat';
import calendar from 'dayjs/plugin/calendar';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import objectSupport from 'dayjs/plugin/objectSupport';
import utc from 'dayjs/plugin/utc'

dayjs.extend(objectSupport);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(calendar);
dayjs.extend(utc);

export default dayjs;

